import React from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'

import Avatar from 'components/avatar/avatar'
import styles from './avatar.scss'

const MainTopbarAvatar = props => {
	if (props.userImage) {
		return (
			<div styleName='wrapper' onClick={props.onClick}>
				<div styleName='image-container'>
					<Avatar src={props.userImage} />
				</div>
			</div>
		)
	} else {
		return null
	}
}

MainTopbarAvatar.propTypes = {
	userImage: PropTypes.string,
	onClick: PropTypes.func,
}

MainTopbarAvatar.defaultProps = {
	userImage: '',
	onClick: () => {},
}

export default CSSModules(MainTopbarAvatar, styles, {allowMultiple: true})

export { MainTopbarAvatar }
